import { gql, useMutation } from "@apollo/client";

export const DELETE_FISCAL_YEAR = gql`
  mutation DeleteFiscalYear($fiscalYearId: String!) {
    deleteFiscalYear(fiscalYearId: $fiscalYearId)
  }
`;

export const useDeleteFiscalYear = () => {
  const [deleteFiscalYear] = useMutation(DELETE_FISCAL_YEAR);

  return { deleteFiscalYear };
};
